
define('jst!tasks/tour/_step10',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<h1><%= t("Mobile #tasksfeaturetour") %></h1>\n<p><%= t("And don\'t forget: If you have an Android phone or an iPhone, all your tasks will be available on the go too! #tasksfeaturetour") %></p>\n');
 });

